let language = {
    "privacy:InformationCollect": "我们收集了哪些信息？",
    "privacy:Collected": "谁在收集这些信息，如何收集？",
    "privacy:Log": "日志文件",
    "privacy:DataUsed": "为何收集这些信息，它们将如何被使用？",
    "privacy:GoogleIntegrated": "来自像 Google 这样的集成服务的信息：",
    "privacy:Shared": "这些信息将与谁共享？",
    "privacy:Storage": "本地存储对象（Flash 和 HTML5）",
    "privacy:Security": "安全性",
    "privacy:AddtionalInformation": "其他信息",
    "privacy:ChildrenPrivacy": "儿童隐私",
    "privacy:ChangePolicy": "隐私政策的变更",
    "privacy:UserChoice": "用户访问和选择",
    "privacy:ContactUs": "联系我们",
    "privacy:ContactWriting": "当您以书面形式联系我们时",
    "privacy:Affiliates": "对于附属机构：我们收集和存储的信息",
    "privacy:Access": "我们团队中的谁有权限访问"
};

export { language }
